// extracted by mini-css-extract-plugin
export default {"commonBlock":"classes_commonBlock__KZU3G","commonBlockSubblocks":"classes_commonBlockSubblocks__e-ovz"};